/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import vue from '../../../main';


function buildMenu() {
  let menuItems = [
    {
      url: "/",
      name: "Home",
      slug: "home",
      icon: "HomeIcon",
    },
  ];
  let dnaMenuItem = {
    header: "DNA",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        url: "/dna/kits",
        name: "DNA Kits",
        icon: "ListIcon",
        slug:"kit",
        isDisabled: vue.$acl.not.check('isCsr'),
      },
      {
        url: "/dna/purchased-kits",
        name: "Purchased Kits",
        icon: "ShoppingBagIcon",
        slug:"purchasedKits",
        isDisabled: vue.$acl.not.check('isCsr'),
      },
      {
        url: "/dna/replace-kit",
        name: "Replace Kit",
        icon: "EditIcon",
        slug:"replaceKit",
        isDisabled: vue.$acl.not.check('isCsr'),
      },
    ]
  };
  let customerServiceMenuItem =   {
    header: "Customer Service",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        url: "/users/list",
        name: "Users",
        slug: "email",
        icon: "UserIcon",
        i18n: "Users",
        isDisabled: vue.$acl.not.check('isCsr'),
      },
      {
        url: "/clients/list",
        name: "Clients",
        slug: "email",
        icon: "UsersIcon",
        i18n: "Clients",
        isDisabled: vue.$acl.not.check('isCsr'),
      },
    ]
  };
  let aclPermissionsTestMenuItem =   {
    header: "ACL Permissions",
    icon: "HomeIcon",
    i18n: "Dashboard",
    items: [
      {
        url: '/a',
        name: "isAdmin",
        isDisabled: vue.$acl.not.check('isAdmin'),
        slug: "is-admin",
        i18n: "isAdmin",
      },
      {
        url: '/b',
        name: "isCsr",
        isDisabled: vue.$acl.not.check('isCsr'),
        slug: "is-csr",
        i18n: "isCsr",
      },
      {
        url: '/c',
        name: "isProductManager",
        isDisabled: vue.$acl.not.check('isProductManager'),
        slug: "is-product-manager",
        i18n: "isProductManager",
      },
      {
        url: '/d',
        name: "isLoggedIn",
        isDisabled: vue.$acl.not.check('isLoggedIn'),
        slug: "is-logged-in",
        i18n: "isLoggedIn",
      },
      {
        url: '/e',
        name: "isPublic",
        isDisabled: vue.$acl.not.check('isPublic'),
        slug: "is-public",
        i18n: "isPublic",
      },
    ]
  };
  let productManagerMenuItem =   {
    header: "Product/Content",
    url: '/a',
    icon: "ArchiveIcon",
    i18n: "Product/Content",
    items: [
      {
        url: '/content/products/list',
        name: "Products",
        slug: "products",
        icon: "ListIcon",
        i18n: "Products",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
      {
        url: '/content/companies/list',
        name: "Companies",
        slug: "companies",
        icon: "BriefcaseIcon",
        i18n: "Companies",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
      {
        url: '/content/trusted-partners',
        name: "Trusted Partners",
        slug: "trusted-partners",
        icon: "LockIcon",
        i18n: "Trusted Partners",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
      {
        url: '/content/protocol-categories',
        name: "Protocol Categories",
        slug: "protocol-categories",
        icon: "ClipboardIcon",
        i18n: "Protocol Categories",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
      {
        url: '/content/protocols',
        name: "Protocols",
        slug: "protocols",
        icon: "FileTextIcon",
        i18n: "Protocols",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
      {
        url: '/content/books/list',
        name: "Books/Titles",
        slug: "books-titles",
        icon: "BookIcon",
        i18n: "Books/Titles",
        isDisabled: vue.$acl.not.check('isProductManager'),
      },
    ]
  };
  let accountingMenuItem = {
    header: "Accounting",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        url: "/orders/partner-invoices",
        name: "Partner Invoices",
        icon: "FileIcon",
        slug: "partner-invoices"
      },
      {
        url: "/referral-checks/list",
        name: "Referral Checks",
        slug: "referral-checks",
        icon: "DollarSignIcon",
        i18n: "Referral Checks",
        isDisabled: vue.$acl.not.check('isAdmin'),
      },
    ]
  };
  let pushNotificationsMenuItem = {
    header: "Marketing",
    icon: "DollarSignIcon",
    i18n: "Apps",
    items: [
      {
        url: "/push-notifications/send",
        name: "Push Notifications",
        slug: "push-notifications",
        icon: "AlertCircleIcon",
      },
    ]
  };

  let ordersMenuItems = {
    header: "Orders",
    icon: "PackageIcon",
    i18n: "Apps",
    items: [
      {
        url: "/orders",
        name: "Order List",
        icon: "ListIcon",
        slug: "orders"
      }
    ]
  };

  if (vue.$acl.check('isCsr')) {
    menuItems.push(customerServiceMenuItem);
    menuItems.push(ordersMenuItems);
    menuItems.push(dnaMenuItem);
  }
  if (vue.$acl.check('isProductManager')) {
    menuItems.push(productManagerMenuItem);
  }
  if (vue.$acl.check('isAdmin')) {
    // menuItems = menuItems.concat(foo);
    menuItems.push(accountingMenuItem);
    menuItems.push(pushNotificationsMenuItem);
  }
  if (process.env.NODE_ENV === 'development') {
    menuItems.push(aclPermissionsTestMenuItem);
  }
  return menuItems;
}
let menu = buildMenu();
export default menu;

// let menuExamples = [
//   {
//     header: "Forms & Table",
//     icon: "Edit3Icon",
//     i18n: "FormsAndTable",
//     items: [
//       {
//         url: null,
//         name: "Form Elements",
//         icon: "CopyIcon",
//         i18n: "FormElements",
//         submenu: [
//           // {
//           //  url: '/forms/form-elements/select',
//           //  name: "Select",
//           //  slug: "form-element-select",
//           //  i18n: "Select",
//           // },
//           {
//             url: '/forms/form-elements/switch',
//             name: "Switch",
//             slug: "form-element-switch",
//             i18n: "Switch",
//           },
//           {
//             url: '/forms/form-elements/checkbox',
//             name: "Checkbox",
//             slug: "form-element-checkbox",
//             i18n: "Checkbox",
//           },
//           {
//             url: '/forms/form-elements/radio',
//             name: "Radio",
//             slug: "form-element-radio",
//             i18n: "Radio",
//           },
//           {
//             url: '/forms/form-elements/input',
//             name: "Input",
//             slug: "form-element-input",
//             i18n: "Input",
//           },
//           {
//             url: '/forms/form-elements/number-input',
//             name: "Number Input",
//             slug: "form-element-number-input",
//             i18n: "NumberInput",
//           },
//           {
//             url: '/forms/form-elements/textarea',
//             name: "Textarea",
//             slug: "form-element-textarea",
//             i18n: "Textarea",
//           },
//         ]
//       },
//       {
//         url: '/forms/form-layouts',
//         name: "Form Layouts",
//         icon: "PackageIcon",
//         slug: "forms-form-layouts",
//         i18n: "FormLayouts",
//       },
//       {
//         url: '/forms/form-wizard',
//         name: "Form Wizard",
//         icon: "PackageIcon",
//         slug: "extra-component-form-wizard",
//         i18n: "FormWizard",
//       },
//       {
//         url: '/forms/form-validation',
//         name: "Form Validation",
//         icon: "CheckCircleIcon",
//         slug: "extra-component-form-validation",
//         i18n: "FormValidation",
//       },
//       {
//         url: '/forms/form-input-group',
//         name: "Form Input Group",
//         icon: "MenuIcon",
//         slug: "extra-component-form-input-group",
//         i18n: "FormInputGroup",
//       },
//       {
//         url: "/ui-elements/table",
//         name: "Table",
//         slug: "table",
//         icon: "GridIcon",
//         i18n: "Table",
//       },
//       {
//         url: "/ui-elements/ag-grid-table",
//         name: "agGrid Table",
//         slug: "ag-grid-table",
//         icon: "GridIcon",
//         i18n: "agGridTable",
//       },
//     ]
//   },
//   {
//     header: "Pages",
//     icon: "FileIcon",
//     i18n: "Pages",
//     items: [
//       {
//         url: '/pages/profile',
//         slug: 'page-profile',
//         name: "Profile",
//         tag: "new",
//         tagColor: "primary",
//         icon: "UserIcon",
//         i18n: "Profile",
//       },
//       {
//         url: '/pages/faq',
//         slug: 'page-faq',
//         name: "FAQ",
//         icon: "HelpCircleIcon",
//         i18n: "FAQ",
//       },
//       {
//         url: '/pages/knowledge-base',
//         slug: 'page-knowledge-base',
//         name: "Knowledge Base",
//         icon: "InfoIcon",
//         i18n: "KnowledgeBase",
//       },
//       {
//         url: '/pages/search',
//         slug: 'page-search',
//         name: "Search",
//         icon: "SearchIcon",
//         i18n: "Search",
//       },
//       {
//         url: '/pages/invoice',
//         slug: 'page-invoice',
//         name: "Invoice",
//         icon: "InfoIcon",
//         i18n: "Invoice",
//       },
//       {
//         url: null,
//         name: "Authentication",
//         icon: "PieChartIcon",
//         i18n: "Authentication",
//         submenu: [
//           {
//             url: '/pages/login',
//             name: "Login",
//             slug: "pages-login",
//             i18n: "Login",
//             target: '_blank',
//           },
//           {
//             url: '/pages/register',
//             name: "Register",
//             slug: "pages-register",
//             i18n: "Register",
//             target: '_blank',
//           },
//           {
//             url: '/pages/forgot-password',
//             name: "Forgot Password",
//             slug: "pages-forgot-password",
//             i18n: "ForgotPassword",
//             target: '_blank',
//           },
//           {
//             url: '/pages/reset-password',
//             name: "Reset Password",
//             slug: "pages-reset-password",
//             i18n: "ResetPassword",
//             target: '_blank',
//           },
//           {
//             url: '/pages/lock-screen',
//             name: "Lock Screen",
//             slug: "pages-lock-screen",
//             i18n: "LockScreen",
//             target: '_blank',
//           },
//         ]
//       },
//       {
//         url: null,
//         name: "Miscellaneous",
//         icon: "CoffeeIcon",
//         i18n: "Miscellaneous",
//         submenu: [
//           {
//             url: '/pages/not-authorized',
//             name: "Not Authorized",
//             slug: "page-not-authorized",
//             icon: "XCircleIcon",
//             i18n: "NotAuthorized",
//             target: '_blank',
//           },
//           {
//             url: '/pages/maintenance',
//             name: "Maintenance",
//             slug: "page-maintenance",
//             icon: "AnchorIcon",
//             i18n: "Maintenance",
//             target: '_blank',
//           },
//           {
//             url: '/pages/comingsoon',
//             slug: 'page-coming-soon',
//             name: "Coming Soon",
//             icon: "ClockIcon",
//             i18n: "ComingSoon",
//             target: '_blank',
//           },
//           {
//             url: '/pages/error-404',
//             name: "404",
//             slug: "page-error-404",
//             i18n: "404",
//             target: '_blank',
//           },
//           {
//             url: '/pages/error-500',
//             name: "500",
//             slug: "page-error-500",
//             i18n: "500",
//             target: '_blank',
//           }
//         ]
//       },
//     ]
//   },
//   {
//     header: "Charts & Maps",
//     icon: "PieChartIcon",
//     i18n: "ChartsAndMaps",
//     items: [
//       {
//         url: null,
//         name: "Charts",
//         icon: "PieChartIcon",
//         tag: '3',
//         tagColor: 'success',
//         i18n: "Charts",
//         submenu: [
//           {
//             url: '/charts-and-maps/charts/apex-charts',
//             name: "Apex Charts",
//             slug: "extra-component-charts-apex-charts",
//             i18n: "ApexCharts",
//           },
//           {
//             url: '/charts-and-maps/charts/chartjs',
//             name: "chartjs",
//             slug: "extra-component-charts-chartjs",
//             i18n: "chartjs",
//           },
//           {
//             url: '/charts-and-maps/charts/echarts',
//             name: "echarts",
//             slug: "extra-component-charts-echarts",
//             i18n: "echarts",
//           },
//         ]
//       },
//       {
//         url: '/charts-and-maps/maps/google-map',
//         name: "Google Map",
//         icon: "MapIcon",
//         slug: "extra-component-maps-google-map",
//         i18n: "GoogleMap",
//       },
//     ]
//   },
//   {
//     header: "Others",
//     icon: "MoreHorizontalIcon",
//     i18n: "Others",
//     items: [
//       {
//         url: null,
//         name: "Menu Levels",
//         icon: "MenuIcon",
//         i18n: "MenuLevels",
//         submenu: [
//           {
//             url: null,
//             name: "Menu Level 2.1",
//             i18n: "MenuLevel2p1",
//           },
//           {
//             url: null,
//             name: "Menu Level 2.2",
//             i18n: "MenuLevel2p2",
//             submenu: [
//               {
//                 url: null,
//                 name: "Menu Level 3.1",
//                 i18n: "MenuLevel3p1",
//               },
//               {
//                 url: null,
//                 name: "Menu Level 3.2",
//                 i18n: "MenuLevel3p2",
//               },
//             ]
//           },
//         ]
//       },
//       {
//         url: null,
//         name: "Disabled Menu",
//         icon: "EyeOffIcon",
//         i18n: "DisabledMenu",
//         isDisabled: true,
//       },
//       {
//         url: null,
//         name: "Support",
//         icon: "SmileIcon",
//         i18n: "Support",
//         submenu: [
//           {
//             url: 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/',
//             name: "Documentation",
//             icon: "BookOpenIcon",
//             slug: "external",
//             i18n: "Documentation",
//             target: "_blank"
//           },
//           {
//             url: 'https://pixinvent.ticksy.com/',
//             name: "Raise Support",
//             icon: "LifeBuoyIcon",
//             slug: "external",
//             i18n: "RaiseSupport",
//             target: "_blank"
//           },
//         ]
//       },
//     ]
//   }
// ]
